import * as UTILS from "../../../config/utils";
import React, { Component } from "react";
import ReactDOM from "react-dom";

import "react-bootstrap";
import { connect } from "react-redux";

import $ from "jquery/dist/jquery.js";
import { Businesses } from "../../../config/Helper";
import destinationApi from "../../../api/destinationApi";
import SingleServiceBody from "./SingleServiceBody";
import Breadcrumb from "../Breadcrumb";
import { lang } from "../../../config/lang";
import SingleSlider from "../../../components/SingleSlider";
import { withRouter } from "react-router-dom";
class SingleServiceBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arrImage: [],
            title: "",
            description: "",
            destinationTitle: "",
            destinationID: 0,
            isData: false,
            style: 0,
            curPage: 1,
        };
        this.serviceID = this.props.serviceID;
        this.business = Businesses.indexOf("service");
        this.lang = props.language.lang_key;
        this.isloading = true;

        this.getService = this.getService.bind(this);
        this.showFooter = this.showFooter.bind(this);
        this.hidePreloader = this.hidePreloader.bind(this);
    }

    componentWillMount() {
        this.getService(false);
    }

    componentDidMount() {
        window.checkSize();
        this.showFooter(false);
    }

    componentWillUnmount() {}

    componentWillReceiveProps(newProps) {
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getService(true);
        }
        if (this.serviceID !== newProps.serviceID) {
            this.serviceID = newProps.serviceID;
            ReactDOM.findDOMNode(this.refs.preloader).style.visibility =
                "visible";
            ReactDOM.unmountComponentAtNode(
                document.getElementById("single_slider_container")
            );
            this.getService(false);
        }
        const search = this.props.history.location.search.split("?");
        let queryParams;
        if (search.length > 1) {
            const query = search[1].split("=");

            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
                this.setState({ curPage: queryParams.page });
            }
        }
        this.setState({
            id: parseInt(newProps.match.params.id, 10),
            business: Businesses.indexOf(newProps.match.params.business),
        });
    }

    getService(changeLang) {
        this.isloading = true;
        destinationApi.getService(this.serviceID).then((json) => {
            if (json.status === 200 && json.data) {
                this.isloading = false;
                this.setState({
                    title: json.data.title,
                    description: json.data.description,
                    arrImage: json.data.media,
                    destinationTitle: json.data.destination_title,
                    destinationID: json.data.destination,
                    isData: true,
                    style: json.data.style,
                });

                if (changeLang === false) {
                    setTimeout(this.hidePreloader, 400);
                    ReactDOM.render(
                        <SingleSlider
                            media={this.state.arrImage}
                            title={json.data.title}
                            business={this.business}
                            id={this.serviceID}
                        />,
                        document.getElementById("single_slider_container")
                    );
                    window.playVideo();
                }
                window.contentWayPoint();
            } else {
                if (json.status === 200 && json.data === "") {
                    this.setState({
                        isData: false,
                    });
                }
            }
        });
    }

    showFooter(willShow) {
        $("#footer").css("visibility", willShow ? "visible" : "hidden");
    }

    hidePreloader() {
        ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "hidden";
        this.showFooter(true);
    }

    render() {
        if (this.state.isData === false && this.isloading === false) {
            return (
                <div className="ftco-section">
                    {/* <div className={"return-title"} onClick={() => { this.props.history.push(`/portfolio?page=${this.state.curPage}`) }}> 목록으로 가기</div> */}
                    <Breadcrumb
                        pageTitle={this.state.title}
                        businessTitle={lang("destination")}
                        url="/destination"
                        placeTitle={null}
                        placeID={null}
                    />
                    <h4 className="container">{lang("no_data")}</h4>
                </div>
            );
        } else {
            return (
                <div className="ftco-revolution-section">
                    {/* <div className={"return-title"} onClick={() => { this.props.history.push(`/portfolio?page=${this.state.curPage}`) }}> 목록으로 가기</div> */}
                    <Breadcrumb
                        pageTitle={this.state.title}
                        businessTitle={lang("destination")}
                        url="/destination"
                        placeTitle={this.state.destinationTitle}
                        placeID={this.state.destinationID}
                        showTitle={this.state.style < 2}
                    />
                    <section className="detail-blog des">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 pr-lg-4">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {this.state.style === 0 && (
                                                <div>
                                                    <div id="single_slider_container"></div>
                                                    <div
                                                        className="preloader"
                                                        id="preloader"
                                                        ref="preloader"
                                                    >
                                                        <div className="spinner"></div>
                                                    </div>
                                                    <div
                                                        className="description ftco-animate"
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state
                                                                .description,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            {this.state.style === 1 && (
                                                <div>
                                                    <div
                                                        className="description ftco-animate"
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state
                                                                .description,
                                                        }}
                                                    />
                                                    <div
                                                        className="mt-5"
                                                        id="single_slider_container"
                                                    ></div>
                                                    <div
                                                        className="preloader"
                                                        id="preloader"
                                                        ref="preloader"
                                                    >
                                                        <div className="spinner"></div>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.style === 2 && (
                                                <div>
                                                    <div id="single_slider_container"></div>
                                                    <div
                                                        className="preloader"
                                                        id="preloader"
                                                        ref="preloader"
                                                    >
                                                        <div className="spinner"></div>
                                                    </div>

                                                    <h2
                                                        className="mb-5 figure fadeIn animated"
                                                        style={{
                                                            textIndent:
                                                                localStorage.getItem(
                                                                    "language"
                                                                ) === "cn"
                                                                    ? "21.25pt"
                                                                    : "14.5pt",
                                                        }}
                                                        data-animate="fadeIn"
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state
                                                                .title,
                                                        }}
                                                    ></h2>

                                                    <div
                                                        className="description ftco-animate"
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.state
                                                                .description,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <SingleServiceBody
                                    destinationID={this.state.destinationID}
                                    serviceID={this.serviceID}
                                    otherServiceTitle={
                                        this.props.otherServiceTitle
                                    }
                                    serviceExperienceTitle={
                                        this.props.serviceExperienceTitle
                                    }
                                />
                            </div>
                        </div>
                    </section>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
    };
}
export default withRouter(connect(mapStateToProps)(SingleServiceBlock));
